import { COPY } from './copyMap';

// schema.org payloads for the public, crawlable surfaces.
//
// 87% of new users arrive from organic search and the app shipped no structured
// data at all. The FAQ in particular is already built expanded-in-the-DOM for
// crawlability — marking it up as a FAQPage is the obvious completion of work
// that was already half-done.
//
// Kept in contracts/ rather than inline in the pages so the site URL and brand
// identity are declared once.

export const SITE_URL = 'https://mogged.app';

export const ORGANIZATION_LD = Object.freeze({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: COPY.BRAND_NAME,
  url: SITE_URL,
  logo: `${SITE_URL}/logo512.png`,
  description: COPY.MARKETING_BODY,
});

export const WEBSITE_LD = Object.freeze({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: COPY.BRAND_NAME,
  url: SITE_URL,
});

// Built from the same COPY.FAQ_ITEMS the page renders, so the markup can never
// drift from the visible answers (which Google treats as cloaking).
export function faqPageLd(items = COPY.FAQ_ITEMS) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: (items || []).map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: { '@type': 'Answer', text: item.answer },
    })),
  };
}
